import React from 'react';
import { useReveal } from '../lib/useReveal';
import { CheckIcon } from '../lib/icons';
const CERT_IMG = 'https://cdn.magicpatterns.com/uploads/k4tfR9gQgzRYyF5zHSfqNm/ChatGPT_Image_23_feb_2026,_11_08_07.png';
export function CertificateSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#f5ede0] py-20 md:py-28 px-4 overflow-hidden" data-id="element-108">
      <div className="container mx-auto max-w-5xl" data-id="element-109">
        <div ref={ref1} className={`reveal text-center mb-14 ${vis1 ? 'is-visible' : ''}`} data-id="element-110">
          <div className="inline-flex items-center gap-2 text-[#b8860b] text-xs font-bold tracking-[0.25em] uppercase mb-5" data-id="element-111">
            <span className="w-8 h-px bg-[#b8860b]/40" data-id="element-112"></span>
            Reconocimiento oficial
            <span className="w-8 h-px bg-[#b8860b]/40" data-id="element-113"></span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#2a1f0e] mb-4 leading-tight" data-id="element-114">
            Tu Curso{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#b8860b] via-[#e8c44a] to-[#b8860b]" data-id="element-115">
              Certificado
            </span>
          </h2>
          <p className="text-lg md:text-xl text-[#5c4a2a]/80 max-w-2xl mx-auto leading-relaxed" data-id="element-116">
            Recibirás tu certificado que acredita tu iniciación y entrenamiento
            en Reiki.
          </p>
        </div>

        <div ref={ref2} className={`reveal flex flex-col md:flex-row items-center gap-10 md:gap-16 ${vis2 ? 'is-visible' : ''}`} data-id="element-117">
          {/* Certificate image */}
          <div className="w-full md:w-1/2 flex-shrink-0" data-id="element-118">
            <div className="relative group" data-id="element-119">
              <div className="absolute -inset-4 bg-gradient-to-br from-[#d4a017]/20 via-[#f0c040]/15 to-[#5a8a6a]/10 rounded-3xl blur-2xl opacity-80" data-id="element-120"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-[0_12px_60px_rgba(184,134,11,0.25)] border border-[#d4a017]/20" data-id="element-121">
                <img src={CERT_IMG} alt="Certificado de Reiki" className="w-full object-cover" data-id="element-122" />
              </div>
            </div>
          </div>

          {/* Benefits */}
          <div className="w-full md:w-1/2 space-y-5" data-id="element-123">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#2a1f0e] mb-6" data-id="element-124">
              ¿Qué acredita tu certificado?
            </h3>
            {['Haber completado la formación integral en Reiki', 'Iniciación y entrenamiento en técnicas energéticas', 'Capacidad para realizar sesiones de Reiki', 'Formación en los 3 niveles del sistema Reiki', 'Base profesional para ofrecer terapias'].map((item, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-125">
                <div className="mt-1 bg-[#d4a017]/15 p-1.5 rounded-full flex-shrink-0 border border-[#d4a017]/30" data-id="element-126">
                  <CheckIcon className="w-4 h-4 text-[#b8860b]" strokeWidth={3} data-id="element-127" />
                </div>
                <span className="text-[#3a2a10] text-lg leading-snug" data-id="element-128">
                  {item}
                </span>
              </div>)}

            <div className="mt-8 bg-gradient-to-r from-[#d4a017]/10 to-[#5a8a6a]/10 border border-[#d4a017]/25 rounded-2xl px-6 py-4" data-id="element-129">
              <p className="text-[#2a1f0e] font-serif font-bold text-lg text-center" data-id="element-130">
                🏅 Tu formación queda respaldada. Tu habilidad, reconocida.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}